import * as svg from "../../../assets/question-solid-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const QuestionSolidIcon = iconBuilder(svg, "QuestionSolidIcon", "0 0 12 13");
